/** @format */
import { Injectable } from '@angular/core';
import { dateUtils } from 'common-typescript/constants';
import { ExternalSignatureRequestStatus, SignatureRequestBasicInfo } from 'common-typescript/types';

@Injectable({
    providedIn: 'root',
})
export class SignatureRequestUtilityService {
    /**
     * Finds the signature request that should be shown to the user from the given list of all signature requests.
     * The signature request that should be shown is the one with the highest priority status (COMPLETE > PENDING_SIGNATURE > CANCELLED and other)
     * that has been last modified.
     *
     * @param signatureRequests List of all signature requests for a graduation
     */
    findActiveSignatureRequestForGraduation(signatureRequests: SignatureRequestBasicInfo[]): SignatureRequestBasicInfo | null {
        if (signatureRequests.length === 0) {
            return null;
        }
        const byState = Object.groupBy(signatureRequests, request => request.externalSignatureRequestStatus);
        // The backend should not allow there to be multiple COMPLETE or PENDING_SIGNATURE requests, but we'll just sort them all anyway
        for (const [key, value] of Object.entries(byState)) {
            // Most recently modified first
            byState[key as ExternalSignatureRequestStatus] = value.sort((a, b) => {
                const momA = dateUtils.createMoment(a.metadata.lastModifiedOn);
                const momB = dateUtils.createMoment(b.metadata.lastModifiedOn);
                if (momA === null && momB === null) {
                    return 0;
                }
                if (momA === null) {
                    return 1;
                }
                if (momB === null) {
                    return -1;
                }
                return momB.diff(momA);
            });
        }
        // Ensure that new added types trigger compilation error here,
        // new types should be ordered in the stateOrder object
        const stateOrder: Record<ExternalSignatureRequestStatus, ExternalSignatureRequestStatus> = {
            COMPLETE: 'COMPLETE',
            PENDING_SIGNATURE: 'PENDING_SIGNATURE',
            CANCELLED: 'CANCELLED',
        };
        const stateOrderKeys = Object.keys(stateOrder) as ExternalSignatureRequestStatus[];
        for (const state of stateOrderKeys) {
            if (byState[state]?.length > 0) {
                return byState[state][0];
            }
        }
        return null;
    }
}
